import React from 'react';
import FilterBar from '../../components/filters/FilterBar';
import { TransactionMetrics } from '../../components/dashboard/metrics';
import PageLayout from '../../components/layout/PageLayout';
import ErrorBoundary from '../../components/ui/ErrorBoundary';
import { useFilterPersistence } from '../../hooks/useFilterPersistence';
import { useSettings } from '../../contexts/SettingsContext';
import { PAGE_INFO, FILTER_PERIODS } from '../../constants';
import './Transactions.css';

/**
 * Transactions Page Component
 * Transaction history and metrics
 */
const Transactions = () => {
  const { period, setPeriod } = useFilterPersistence({
    pageKey: 'transactions',
    defaultPeriod: FILTER_PERIODS.ALL
  });
  const settings = useSettings();
  const compact = settings.compactMode;

  const filters = (
    <FilterBar
      period={period}
      onPeriodChange={setPeriod}
    />
  );

  return (
    <ErrorBoundary>
      <PageLayout
        title={PAGE_INFO.TRANSACTIONS.title}
        description={PAGE_INFO.TRANSACTIONS.description}
        filters={filters}
      >
        <div className="transactions-content">
          <TransactionMetrics period={period} compact={compact} />
        </div>
      </PageLayout>
    </ErrorBoundary>
  );
};

export default Transactions;

